const { debounce } = require('lodash');

const CategorySelectionList = require('../categories/category-selection-list');

class CategoryHeaderController {
    constructor($scope, settings, categoriesService, shopPageStateService, analyticsService, moveFocus) {
        this.$scope = $scope;
        this.settings = settings;
        this.categoriesService = categoriesService;
        this.shopPageStateService = shopPageStateService;
        this.analyticsService = analyticsService;
        this.moveFocus = moveFocus;
    }

    $onInit() {
        this.categoriesService.getAll();

        this.selectedCategories = new CategorySelectionList();

        this.categoriesLoaded = false;
        this.categoriesService.getAll().then(() => {
            if (this.selectedCategories.department) {
                this.selectDepartment(this.categoriesService.getById(this.selectedCategories.department.NodeId));
            }
            this.categoriesLoaded = true;
        });

        this.$scope.$on('$stateChangeStart', () => this.closeMenu());

        this.onMouseEnterDepartment = debounce(
            ($event, department) => {
                if (this.checkEvent($event)) {
                    this.$scope.$apply(() => this.selectDepartment(department));
                }
            },
            this.settings.pies ? this.settings.pies.overlayOnHoverDelay : 150,
            { leading: false, trailing: true },
        );
    }

    checkEvent(event) {
        return event ? event.type === 'click' || (event.type.indexOf('mouse') >= 0 && !this.settings.category.disableCategoryMenuHover) : true;
    }

    onMouseLeaveDepartment($event) {
        if (this.checkEvent($event)) {
            this.onMouseEnterDepartment.cancel();
        }
    }

    onTouchDepartment(department) {
        this.toggleMenu(department);
    }

    selectDepartment(department) {
        // If we are opening the menu for the page we are currently on, we use the
        // selected categories so we can highlight the current page category.
        this.selectedCategories = this.categoriesService.currentCategories.department === department
            ? this.categoriesService.currentCategories.clone()
            : new CategorySelectionList(this.categoriesService.getCategoryTree(department.NodeId));

        this.shopPageStateService.toggleBodyScroll(false);

        this.moveFocus('.categoryHeader-menuHeaderTitle');
    }

    selectCategory(event, category) {
        if (this.checkEvent(event)) {
            if (event.type === 'click') {
                event.preventDefault();
            }

            this.selectedCategories = new CategorySelectionList(this.categoriesService.getCategoryTree(category.NodeId));

            this.moveFocus('._subCategoryNav .categoriesNavigation');
        }
    }

    onKeydownHeader($event) {
        // escape
        if ($event.which === 27) {
            this.moveFocus('._departmentNav .categoryHeader-navigationLink.is-active', true);
            this.closeMenu();
        }
    }

    toggleMenu(department) {
        if (this.isMenuOpen && this.selectedCategories.department === department) {
            this.closeMenu();
        } else {
            this.selectDepartment(department);
        }
    }

    closeMenu($event) {
        if (this.checkEvent($event)) {
            this.selectedCategories = new CategorySelectionList();
            this.shopPageStateService.toggleBodyScroll(true);
        }
    }

    isActiveDepartment(department) {
        return department === (this.selectedCategories.department || this.categoriesService.currentCategories.department);
    }

    get isMenuOpen() {
        return this.selectedCategories.hasSelectedCategories;
    }

    pushDataToAnalyticsService() {
        this.analyticsService.push({
            data: {
                trackingType: 'link',
            },
            type: this.analyticsService.mapperTypes.customEvent.menuClick,
        });
    }
}

CategoryHeaderController.$inject = ['$scope', 'Settings', 'CategoriesService', 'ShopPageStateService', 'AnalyticsService', 'MoveFocus'];

const categoryHeaderComponentDefinition = {
    transclude: true,
    controller: CategoryHeaderController,
    template: require('./category-header.component.html').trim(),
};

module.exports = {
    CategoryHeaderController,
    categoryHeaderComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/header/category-header.component.js